import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Metrological_traceability_Form from "./metrological_traceability_Form/Metrological_traceability_Form";
import Metrological_traceability_table from "./metrological_traceability_table/Metrological_traceability_table";
import {
  Create,
  GetAll,
} from "../../../../../../../src/features/admin/quality_management/resource_requirement/metrological_traceability/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Metrological_traceability() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const metrological_traceability = useSelector(
    (state) => state.metrological_traceability,
  );

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: metrological_traceability.per_page,
      }),
    );
  };

  const permissions = useSelector((state) => state.auth.permissions);
                        
  const haveReadPermission = permissions?.includes(FixIDS.metrological_traceability.List);
  const haveAddPermission = permissions?.includes(FixIDS.metrological_traceability.Add);
  

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage]);
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="Metrological Traceability" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
              All measurements performed in the laboratory are traceable to
              national or international standards through an unbroken chain of
              calibrations. Each calibration is supported by valid certificates
              indicating measurement uncertainty and reference standards used.
              This ensures the reliability, accuracy, and global comparability
              of test results in compliance with ISO/IEC 17025:2017 requirements
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          { haveAddPermission && <Metrological_traceability_Form fetchCustomers={fetchCustomers} />}
        </div>

        <div className="imperiality_table_div">
          { haveReadPermission && <Metrological_traceability_table
            data={metrological_traceability}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
          /> }
        </div>
      </section>
    </>
  );
}

export default Metrological_traceability;
